import { render, staticRenderFns } from "./LabelCloud.vue?vue&type=template&id=90ec50d4&scoped=true&"
import script from "./LabelCloud.vue?vue&type=script&lang=js&"
export * from "./LabelCloud.vue?vue&type=script&lang=js&"
import style0 from "./LabelCloud.vue?vue&type=style&index=0&id=90ec50d4&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ec50d4",
  null
  
)

export default component.exports